module.exports = __webpack_public_path__ + "photo-email2-sm.58f39b4919d4f8cae623.jpg";


//////////////////
// WEBPACK FOOTER
// /Users/nicholasmurray/Documents/firebase-websites/CommunityAdviceNMD/src/assets/images/photo-email2-sm.jpg
// module id = ../../../../../src/assets/images/photo-email2-sm.jpg
// module chunks = main